import { Link } from "react-router-dom";

const STATUS_STYLES = {
  completed: "bg-white text-[#060D1A]",
  in_progress: "border border-white/40 text-white",
  waiting_on_client: "bg-white/15 text-white border border-white/25",
  not_started: "border border-white/10 text-slate-500",
};

const STATUS_LABELS = {
  completed: "Completed",
  in_progress: "In progress",
  waiting_on_client: "Needs you",
  not_started: "Not started",
};

export const ClientTimeline = ({ data }) => {
  const pct = data.progress.total ? Math.round((data.progress.done / data.progress.total) * 100) : 0;
  const current = data.timeline.filter((t) => t.status === "in_progress" || t.status === "waiting_on_client");
  const next = data.timeline.filter((t) => t.status === "not_started").slice(0, 3);

  return (
    <div className="rounded-3xl border border-white/15 bg-[#0F1B31]/80 p-6 sm:p-8" data-testid="portal-timeline">
      <div className="flex items-end justify-between mb-4">
        <p className="font-mono-label text-xs uppercase tracking-[0.3em] text-slate-400">Your First 30 Days</p>
        <p className="font-mono-label text-xs text-slate-500">Day {data.day_number} of 30</p>
      </div>
      <div className="h-2 rounded-full bg-white/10 overflow-hidden mb-2">
        <div className="h-full bg-white transition-all duration-700" style={{ width: `${pct}%` }} />
      </div>
      <p className="text-sm text-slate-400 mb-8" data-testid="portal-progress-text">
        {data.progress.done} of {data.progress.total} steps completed ({pct}%)
      </p>

      {current.length > 0 && (
        <div className="mb-6 rounded-2xl border border-white/15 bg-white/[0.04] p-4">
          <p className="font-mono-label text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-2">Currently working on</p>
          {current.map((t) => (
            <p key={t.day} className="text-sm text-white">Day {t.day} — {t.task}</p>
          ))}
        </div>
      )}
      {next.length > 0 && (
        <div className="mb-8 rounded-2xl border border-white/10 p-4">
          <p className="font-mono-label text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-2">Coming next</p>
          {next.map((t) => (
            <p key={t.day} className="text-sm text-slate-300">Day {t.day} — {t.task}</p>
          ))}
        </div>
      )}

      <div className="space-y-2">
        {data.timeline.map((t) => (
          <div
            key={t.day}
            data-testid={`portal-day-row-${t.day}`}
            className="flex items-start gap-4 rounded-xl border border-white/5 px-4 py-3"
          >
            <span className="font-mono-label text-xs text-slate-500 w-10 shrink-0 pt-0.5">D{t.day}</span>
            <div className="min-w-0 flex-1">
              <p className={`text-sm ${t.status === "completed" ? "text-white" : "text-slate-300"}`}>{t.task}</p>
              {t.status === "completed" && t.update && (
                <p className="text-xs text-slate-400 mt-1">{t.update}</p>
              )}
            </div>
            <span className={`shrink-0 rounded-full px-3 py-1 text-[11px] font-semibold ${STATUS_STYLES[t.status]}`}>
              {STATUS_LABELS[t.status]}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export const PortalHeader = ({ user, right }) => (
  <header className="border-b border-white/10">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
      <Link to="/" className="font-display font-bold text-lg text-white" data-testid="portal-brand">
        OG<span className="hidden min-[420px]:inline text-slate-500 font-mono-label text-xs ml-2 tracking-[0.3em]">SOLUTIONS</span>
      </Link>
      <div className="flex items-center gap-3">{right}</div>
    </div>
  </header>
);
